
// ExibirApagar.js

import React, { useState, useEffect } from 'react';
import DatepickerField from './DatepickerField';  // Importar o campo de data
import CurrencyField from './CurrencyField';      // Importar o campo de moeda
import ModalDetalhesFornecedor from './ModalDetalhesFornecedor'; // Certifique-se de que o caminho está correto
import Box from '@mui/material/Box';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import '../App.css';
import './ModalDetalhesCliente.css';
import './ModalContasAreceber.css';

const ExibirApagar = ({ apagar, handleSaveApagar, handleCancelaExibe }) => {
  
  const [detalhesFornecedor, setDetalhesFornecedor] = useState(false);

  const [formData, setFormData] = useState({
    nomefor: '',  // Valor inicial vazio
    cnpjfor: '',  // Valor inicial vazio
    codfor: '',  // Valor inicial vazio
    idfornecedor: '',  // Estado para armazenar dados do fornecedor selecionado
    dtpagamento: '',  // Valor inicial vazio
    valpagamento: 0, // Valor do pagamento
    desconto: 0,         // Desconto aplicado
    valmulta: 0,         // Multa aplicada
    valjuros: 0,         // Juros aplicados
  });

// Atualiza o estado do formulário com os valores de "apagar"
useEffect(() => {
  if (apagar) {
    // Atualiza o estado do formulário com os valores de "apagar" (editáveis)
    setFormData({
      ...apagar,
      fornecedorid: apagar.fornecedor ? apagar.fornecedor.id : '',
      nomefor: apagar.fornecedor ? apagar.fornecedor.nomefor : '',
      codfor: apagar.fornecedor ? apagar.fornecedor.codfor : '',
      cnpjfor: apagar.fornecedor ? apagar.fornecedor.cnpjfor : '',
      dtpagamento: apagar.dtpagamento || '',   // Não preenche com a data atual
      valpagamento: apagar.valpagamento || 0,  // Valor do pagamento
      desconto: apagar.desconto || 0,          // Desconto aplicado
      valmulta: apagar.valmulta || 0,          // Multa aplicada
      valjuros: apagar.valjuros || 0,          // Juros aplicados
    });
  }
}, [apagar]); // Executa o efeito sempre que "apagar" mudar

  // Função para abrir ou fechar os detalhes do fornecedor
  const toggleDetalhesFornecedor = () => {
    setDetalhesFornecedor(!detalhesFornecedor);
  };


  // Função para manipular a mudança nos campos
  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  // Função para formatar o valor de moeda brasileira
  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  // Função para formatar a data no formato "DD/MM/YYYY"
  const formatarData = (data) => {
    if (!data) return "Data não disponível";
    const partes = data.split('-');
    if (partes.length !== 3) return "Data inválida";
    const [ano, mes, dia] = partes;
    return `${dia}/${mes}/${ano}`;
  };


// Função para calcular o valor do Pagamento após aplicar desconto, multa e juros
const calcularTotal = () => {
  const { desconto, valmulta, valjuros, dtpagamento } = formData;
  const valparcela = apagar.valparcela; // Acesse o valor da parcela

  // Verifica se a data de pagamento foi preenchida
  if (!dtpagamento) {
  return 0; // Retorna 0 ou outro valor padrão se a data não for fornecida
  //alert("Por favor, preencha a data de pagamento antes de calcular o total.");
  }
  // Calcule o valor do pagamento apenas se a data de pagamento existir
  return valparcela - desconto + valmulta + valjuros;
  };
  
  
  const handleSubmit = async () => {
    try {
      await api.put(`/apagar/atualizarapagar/${apagar.id}`, formData, {
        headers: { 'Content-Type': 'application/json'},
      });

      alert('Registro atualizado com sucesso!');
      handleSaveApagar(formData); // Atualiza a exibição dos dados
    } catch (error) {
      console.error('Erro ao atualizar registro:', error);
      alert('Erro ao atualizar registro.');
    }
  };

  return (
    <div style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto', paddingTop: '10px' }}>
      <h3 translate="no">{'Contas a Pagar'}</h3>

      {apagar ? (
        <div style={{ textAlign: 'left', margin: '0 20px' }}>

          <div style={{ display: 'flex', marginBottom: '0px' }}>
          <div style={{ marginRight: '0px', width: '420px' }}>
            <label style={{ display: 'block', width: '420px', marginRight: '0px' }}>Fornecedor</label>
            <input type="text" value={apagar.nomefor} readOnly style={{ width: '420px', height: '30px' }} />
          </div>
                      
          <div style={{ width: '160px' }}>
            <label style={{ display: 'block', width: '150px', marginBottom: '0px', marginLeft: '20px' }}>CNPJ Fornecedor</label>
            <input type="text" value={apagar.cnpjfor} readOnly style={{ width: '160px', height: '30px', marginLeft: '20px' }} />
          </div>

            <div style={{ width: '120px' }}>
              <button className="btn-truncate" title="Detalhes do Fornecedor"
                onClick={toggleDetalhesFornecedor} style={{ width: '120px', marginTop: '24px', marginLeft: '40px', height: '30px' }}>Fornecedor</button>
            </div>
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '10px' }}>
            <div style={{ width: '60px' }}>
              <label>Compra</label>
              <input type="text" value={apagar.codcompra} readOnly style={{ width: '60px', height: '30px' }} />
            </div>

            <div style={{ width: '100px', marginLeft: '20px' }}>
              <label>Nota Fiscal</label>
              <input type="text" value={apagar.nfcompra} readOnly style={{ width: '100px', height: '30px' }} />
            </div>

            <div style={{ width: '120px', marginLeft: '20px' }}>
              <label>Valor Compra</label>
              <input type="text" value={formatarMoeda(apagar.valcompra)} readOnly style={{ width: '120px', height: '30px' }} />
            </div>

            <div style={{ width: '120px', marginLeft: '20px' }}>
              <label translate="no">Dt Compra</label>
              <input type="text" value={formatarData(apagar.dtcompra)} readOnly style={{ width: '120px', height: '30px' }} />
            </div>

            <div style={{ width: '120px', marginLeft: '20px' }}>
              <label translate="no">Dt Vencimento</label>
              <input type="text" value={formatarData(apagar.dtvencimento)} readOnly style={{ width: '120px', height: '30px' }} />
            </div>

            <div style={{ width: '120px', marginLeft: '20px' }}>
              <label translate="no">Dt Pagamento</label>
              <DatepickerField
                value={formData.dtpagamento}
                onChange={(value) => handleChange('dtpagamento', value)}
              />
            </div>
          </div>

          
          <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '30px' }}>
            
            <div style={{ width: '60px', marginRight: '20px' }}>
              <label>Parcela</label>
              <input type="text" value={apagar.parcela} readOnly style={{ width: '60px', height: '30px' }} />
            </div>

            <div style={{ width: '100px', marginRight: '20px' }}>
              <label>Valor Parcela</label>
              <input type="text" value={formatarMoeda(apagar.valparcela)} readOnly style={{ width: '100px', height: '30px' }} />
            </div>

            <div style={{ width: '100px', marginRight: '20px' }}>
              <label>Desconto</label>
              <CurrencyField
                value={formData.desconto}
                onChange={(value) => handleChange('desconto', value)}
              />
            </div>

            <div style={{ width: '100px', marginLeft: '20px', marginRight: '20px' }}>
              <label translate="no">Multa</label>
              <CurrencyField
                value={formData.valmulta}
                onChange={(value) => handleChange('valmulta', value)}
              />
            </div>

            <div style={{ width: '100px', marginLeft: '20px', marginRight: '20px' }}>
              <label>Juros</label>
              <CurrencyField
                value={formData.valjuros}
                onChange={(value) => handleChange('valjuros', value)}
              />
            </div>

            <div style={{ width: '120px', marginLeft: '20px' }}>
              <label>Valor Pago</label>
              <input
                type="text"
                value={formatarMoeda(calcularTotal())}
                readOnly
                style={{ width: '120px', height: '30px' }}
              />
            </div>
          </div>

        {detalhesFornecedor && apagar?.fornecedor && (
        <ModalDetalhesFornecedor fornecedor={apagar.fornecedor} fecharDetalhes={toggleDetalhesFornecedor} />
        )}

          <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
            <button
              onClick={handleSubmit}
              style={{
                marginRight: '20px',
                width: '100px',
                height: '40px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Salvar
            </button>

            <button
              type="button"
              onClick={handleCancelaExibe}
              style={{
                width: '100px',
                height: '40px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Fechar
            </button>
          </Box>
        </div>
      ) : (
        <p>Nenhuma conta a pagar disponível.</p>
      )}
    </div>
  );
};

export default ExibirApagar;